import {FeatureCollection, Point} from "geojson"
import {Feature} from "ol"
import {Point as OLPoint} from "ol/geom";
import {GeoJSON} from "ol/format"
import {LayerId} from "./"
import FeatureService from "./FeatureService"

export interface IPointService {
  addPoints(layerId: LayerId, points: FeatureCollection<Point>): void
  toggleLayer(layerId: LayerId, isVisible: boolean): void
}

export class PointService implements IPointService {

  addPoints(layerId: LayerId, points: FeatureCollection<Point>) {
    const formatter = new GeoJSON()
    if (points.features) {
      let features = formatter.readFeatures(points) as Feature<OLPoint>[]
      FeatureService.addFeatures(layerId, features)
    }
  }

  toggleLayer(layerId: LayerId, isVisible: boolean) {
    FeatureService.getLayer(layerId)?.setVisible(isVisible)
  }
}

export default new PointService() as IPointService
